export const CLASS_TYPE = {
  FREE: "free",
  PREMIUM: "premium",
  FREEMIUM: "freemium",
}
